import { buildDiagnosticPayload, createIdempotencyKey } from "./contract.js";
import { FORM_UNAVAILABLE_MESSAGE, requirePublicConfig } from "../config.js";

export const PUBLIC_SUBMISSION_ERROR = "Não foi possível enviar agora. Seus dados continuam preenchidos.";
export { FORM_UNAVAILABLE_MESSAGE };

export async function sendDiagnosticRequest({ config, payload, fetchImpl = globalThis.fetch }) {
  try {
    const response = await fetchImpl(`${config.supabaseUrl}/functions/v1/submit-diagnostic`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        apikey: config.supabasePublishableKey,
      },
      body: JSON.stringify(payload),
    });
    const result = await response.json();

    if (!response.ok) {
      throw new Error(PUBLIC_SUBMISSION_ERROR);
    }

    return result;
  } catch {
    throw new Error(PUBLIC_SUBMISSION_ERROR);
  }
}

export async function submitWithUi({ button, label, status, request }) {
  button.disabled = true;
  label.textContent = "Enviando…";
  status.textContent = "Enviando sua solicitação com segurança.";

  try {
    const result = await request();
    status.textContent = "Solicitação enviada com sucesso.";
    return result;
  } catch (error) {
    status.textContent = error?.message === FORM_UNAVAILABLE_MESSAGE
      ? FORM_UNAVAILABLE_MESSAGE
      : PUBLIC_SUBMISSION_ERROR;
    button.disabled = false;
    label.textContent = "Tentar novamente";
    return null;
  }
}

const form = globalThis.document?.getElementById("diagForm");

if (form) {
  const startedAt = Date.now();
  let idempotencyKey = createIdempotencyKey();
  const status = document.getElementById("formStatus");
  const button = document.getElementById("btnNext");
  const label = document.getElementById("btnNextLabel");

  form.addEventListener("diagnostic:submit", async () => {
    const result = await submitWithUi({
      button,
      label,
      status,
      request: () => {
        const config = requirePublicConfig();
        const payload = buildDiagnosticPayload(new FormData(form), {
          startedAt,
          submittedAt: Date.now(),
          idempotencyKey,
        });

        return sendDiagnosticRequest({ config, payload });
      },
    });

    if (!result) return;

    document.getElementById("formProtocol").textContent = result.protocol;
    form.dispatchEvent(new CustomEvent("diagnostic:success"));
    idempotencyKey = createIdempotencyKey();
  });
}
